import { createFileRoute } from "@tanstack/react-router";

import { BASE_URL, OG_VERSION } from "@/common/links";
import { CliPricing } from "@/landing/components/CliPricing";
import { PAGE_META } from "@/landing/lib/page-meta";

export const Route = createFileRoute("/_landing/pricing")({
  component: PricingPage,
  head: () => ({
    meta: [
      { title: PAGE_META["/pricing"].title },
      { name: "description", content: PAGE_META["/pricing"].description },
      { property: "og:title", content: PAGE_META["/pricing"].title },
      {
        property: "og:description",
        content: PAGE_META["/pricing"].description,
      },
      {
        property: "og:image",
        content: `${BASE_URL}/og/pricing.png?v=${OG_VERSION}`,
      },
      { name: "twitter:title", content: PAGE_META["/pricing"].title },
      {
        name: "twitter:description",
        content: PAGE_META["/pricing"].description,
      },
      {
        name: "twitter:image",
        content: `${BASE_URL}/og/pricing.png?v=${OG_VERSION}`,
      },
    ],
    links: [{ rel: "canonical", href: `${BASE_URL}/pricing` }],
  }),
});

function PricingPage() {
  return <CliPricing />;
}
